// src/services/cookie.js

import { COOKIE_CONFIG } from './config'

class CookieService {
    constructor(config = COOKIE_CONFIG) {
        this.config = config
    }

    // Imposta un cookie
    set(name, value, days = this.config.daysToExpire) {
        const date = new Date()
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))

        const expires = `expires=${date.toUTCString()}`
        const secure = this.config.secure ? '; Secure' : ''
        const sameSite = `; SameSite=${this.config.sameSite}`

        document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=${this.config.path}${secure}${sameSite}`
    }

    // Legge un cookie
    get(name) {
        const cookieName = `${name}=`
        const cookies = document.cookie.split(';')

        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim()
            if (cookie.indexOf(cookieName) === 0) {
                const value = cookie.substring(cookieName.length, cookie.length)
                return decodeURIComponent(value)
            }
        }
        return null
    }

    // Elimina un cookie
    remove(name) {
        this.set(name, '', -1)
    }

    // Verifica se esiste un cookie
    exists(name) {
        return this.get(name) !== null
    }

    // Token specific methods
    setToken(token) {
        if (token) {
            this.set(this.config.tokenName, token)
        } else {
            this.removeToken()
        }
    }

    getToken() {
        return this.get(this.config.tokenName)
    }

    removeToken() {
        this.remove(this.config.tokenName)
    }

    isAuthenticated() {
        return !!this.getToken()
    }

    // Clear all app cookies
    clear() {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            const cookieName = cookie.split('=')[0]
            if (cookieName.startsWith(this.config.tokenName) || cookieName === this.config.tokenName) {
                this.remove(cookieName)
            }
        }
    }
}

export const cookieService = new CookieService()
export default cookieService